import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:4000/api';

function AdminLogin() {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  const handleAdminLogin = async (e) => {
    e.preventDefault();

    if (!credentials.email || !credentials.password) {
      toast.error('Please enter email and password');
      return;
    }

    setLoading(true);
    try {
      // Call backend admin login API
      const response = await axios.post(`${API_BASE}/admin/login`, {
        email: credentials.email,
        password: credentials.password
      });

      if (response.data.token && response.data.user) {
        // Store admin token and user info
        localStorage.setItem('admin_token', response.data.token);
        localStorage.setItem('admin_user', JSON.stringify(response.data.user));
        
        toast.success('Welcome, Admin! 👑');
        navigate('/admin');
      } else {
        toast.error('Invalid admin credentials');
      }
    } catch (error) {
      console.error('Admin login error:', error);
      if (error.response?.status === 401) {
        toast.error('Invalid admin credentials');
      } else if (error.response?.status === 403) {
        toast.error('Access denied - Admin only');
      } else {
        toast.error('Failed to login. Please check your credentials.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-header">
        <h1 className="game-title">
          <span className="zero">ZERO</span>
          <span className="ping">PING</span>
        </h1>
        <p className="tagline">Admin Control Panel</p>
      </div>

      <div className="card" style={{ width: '100%', maxWidth: '450px' }}>
        <div style={{
          textAlign: 'center',
          marginBottom: '30px',
          padding: '20px',
          background: 'linear-gradient(135deg, rgba(255, 0, 255, 0.1), rgba(255, 0, 255, 0.05))',
          borderRadius: '8px',
          border: '1px solid rgba(255, 0, 255, 0.3)'
        }}>
          <div style={{ fontSize: '3rem', marginBottom: '10px' }}>👑</div>
          <h2 style={{ 
            fontSize: '2rem', 
            marginBottom: '10px',
            fontFamily: 'Orbitron, sans-serif',
            color: 'var(--secondary-color)'
          }}>
            ADMIN LOGIN
          </h2>
          <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem' }}>
            Authorized Personnel Only
          </p>
        </div>

        <form onSubmit={handleAdminLogin}>
          <div className="form-group">
            <label className="form-label">Admin Email</label>
            <input
              type="email"
              name="email"
              className="form-input"
              placeholder="admin@zeroping.gg"
              value={credentials.email}
              onChange={handleChange}
              disabled={loading}
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Admin Password</label>
            <input
              type="password"
              name="password"
              className="form-input"
              placeholder="••••••••"
              value={credentials.password}
              onChange={handleChange}
              disabled={loading}
              autoComplete="current-password"
            />
          </div>

          <button 
            type="submit" 
            className="btn btn-secondary" 
            style={{ width: '100%', marginTop: '20px' }}
            disabled={loading}
          >
            {loading ? 'Authenticating...' : 'Login as Admin 👑'}
          </button>

          <div style={{ 
            textAlign: 'center', 
            marginTop: '30px',
            paddingTop: '20px',
            borderTop: '1px solid rgba(255, 255, 255, 0.1)'
          }}>
            <button
              type="button"
              onClick={() => navigate('/')}
              style={{
                background: 'transparent',
                border: 'none',
                color: 'var(--text-secondary)',
                cursor: 'pointer',
                fontSize: '0.9rem',
                textDecoration: 'underline'
              }}
            >
              ← Back to Main Site
            </button>
          </div>
        </form>

        <div style={{
          marginTop: '30px',
          padding: '15px',
          background: 'rgba(255, 170, 0, 0.1)',
          borderRadius: '8px',
          border: '1px solid rgba(255, 170, 0, 0.3)',
          fontSize: '0.85rem',
          color: 'var(--warning-color)'
        }}>
          <strong>⚠️ Security Notice:</strong> This is a restricted area. All actions are logged and monitored.
        </div>
      </div>
    </div>
  );
}

export default AdminLogin;
